import React from 'react';
import ReactDOM from 'react-dom';
import DarabaseLogo from '../components/DarabaseLogo'
import Links from '../components/Links';
import Message from '../components/Message';
import Logo from'../components/Logo'
import '../js/components.js';
import frontSide from '../img/tower/front.jpg';
import backSide from '../img/tower/back.jpg';
import leftSide from '../img/tower/left.jpg';
import rightSide from '../img/tower/right.jpg';
import videoAsset from '../img/video/video.mp4';
import videoThumbnail from '../img/video/thumb.jpg';
import videoCTA from '../img/video/cta.png';
import carouselFront from '../img/carousel/front.jpg';
import carouselRight from '../img/carousel/right.jpg';
import carouselLeft from '../img/carousel/left.jpg';
import carouselRight2 from '../img/carousel/right-2.jpg';
import carouselLeft2 from '../img/carousel/left-2.jpg';
import instTower from '../img/tower/inst-tower.png';

export default class Splash extends React.Component {

    constructor() {
        super();
    }

    componentDidMount() {

        // eslint-disable-next-line no-undef
        if(window.isAdMounted) return;
        // eslint-disable-next-line no-undef
        window.isAdMounted = true;

        // const product = new URLSearchParams(window.location.search).get('product')
        const product = 'video';
        const stage = document.getElementById('stage');
        // let isAdCreated = false;

        if (!document.querySelector('a-scene')) {
            stage.insertAdjacentHTML('beforeend',
                `<a-scene
                    xrextras-loading
                    xrextras-runtime-error
                    xrextras-gesture-detector
                    renderer="colorManagement: true;webgl2: true;"
                    gltf-model="dracoDecoderPath: https://cdn.8thwall.com/web/aframe/draco-decoder/" >
    
                    <a-assets>
                        
                    </a-assets>
    
                    <a-camera
                        id="camera"
                        cursor="fuse: false; rayOrigin: mouse;"
                        raycaster="objects: .cantap"
                        position="0 7 11">
                    </a-camera>
    
                    <a-entity
                        light="
                            type: directional;
                            intensity: 0.5;
                            castShadow: true;
                            shadowMapHeight:2048;
                            shadowMapWidth:2048;
                            shadowCameraTop: 40;
                            shadowCameraBottom: -40;
                            shadowCameraRight: 40;
                            shadowCameraLeft: -40;"
                        position="0 10 15"
                        shadow>
                    </a-entity>
    
                    <a-light
                        type="ambient"
                        intensity="1">
                    </a-light>
    
                    <a-entity class="cantap" id="scene" scale="1 1 1" position="0 2 0"></a-entity>
    
                </a-scene>`)
        }

        // window.schema

        let videoSchema = {
            groundPlane: true,
            type: 'video',
            elements: {
                videoURL: videoAsset,
                thumbnail: videoThumbnail,
                ctaTexture: videoCTA,
                ctaURL: 'https://darabase.com/',
                ringColor: '#ffffff',
                ringRadiusInner: 1,
                ringRadiusOuter: 2.5,
                videoOffsetTop: 5,
                videoWidth: 8,
                videoHeight: 4.5,
                startOpacity: 0.2,
                lookAtUser: true
            },
        }

        let flatImageSchema = {
            groudplane: true,
            type: 'flat-image',
            width: 10,
            height: 5,
            yOffset: 5.5,
            image: 'https://dgb2dzxmmo5cy.cloudfront.net/video-test/thumb.jpg'
        }

        let towerSchema = {
            groundPlane: true,
            type: 'cube-dynamic',
            size: 6,
            height: 12,
            nonActiveHex: '#000',
            sceneComponents: [
                'xrextras-one-finger-rotate'
            ],
            elements: [
                {
                    id: "left",
                    primitive: 'a-plane',
                    texture: leftSide,
                    url: 'https://darabase.com/',
                    components: [
                        'position=val 0 0',
                        'rotation=0 -90 0',
                        'width',
                        'height',
                        'material=transparent:true;',
                        'data-url',
                        'tap-link'
                    ]
                },
                {
                    id: "right",
                    primitive: 'a-plane',
                    texture: rightSide,
                    url: 'https://darabase.com/',
                    components: [
                        'position=val 0 0',
                        'rotation=0 90 0',
                        'width',
                        'height',
                        'material=transparent:true;',
                        'data-url',
                        'tap-link'
                    ]
                },
                {
                    id: "front",
                    primitive: 'a-plane',
                    texture: frontSide,
                    url: 'https://darabase.com',
                    components: [
                        'position=0 0 val',
                        'rotation=0 0 0',
                        'width',
                        'height',
                        'material=transparent:true;',
                        'data-url',
                        'tap-link'
                    ]
                },
                {
                    id: "back",
                    primitive: 'a-plane',
                    texture: backSide,
                    url: 'https://darabase.com/',
                    components: [
                        'position=0 0 val',
                        'rotation=0 -180 0',
                        'width',
                        'height',
                        'material=transparent:true;',
                        'data-url',
                        'tap-link'
                    ]
                },
                {
                    id: "top",
                    primitive: 'a-plane',
                    color: '#000000',
                    components: [
                        'position=0 val 0',
                        'rotation=-90 0 0',
                        'width',
                        'height',
                        'material=transparent:true;'
                    ]
                },
                {
                    id: "bottom",
                    primitive: 'a-plane',
                    color: '#000000',
                    components: [
                        'position=0 val 0',
                        'rotation=90 0 0',
                        'width',
                        'height',
                        'material=transparent:true;'
                    ]
                }
            ]
        };

        let carouselSchema = {
            groundPlane: true,
            splashScreen: '',
            type: 'carousel',
            nonActiveHex: '#000',
            sceneComponents: [
                'one-finger-rotate-inverted',
                'rotate-click-handler'
            ],
            elements: [
                {
                    id: "initial-focal",
                    primitive: 'plane',
                    width: 4,
                    height: 2.25,
                    position: '0 7 -7',
                    rotation: '0 0 0',
                    scale: '1.25 1.25 1.25',
                    classes: ['cantap', 'display-img'],
                    material: {
                        transparent: true,
                        opacity: 1,
                        src: '#img-1'
                    },
                    shadow: {
                        receive: false
                    },
                    texture: carouselFront,
                    url: "https://darabase.com/",
                },
                {
                    id: "i2",
                    primitive: 'plane',
                    width: 4,
                    height: 2.25,
                    position: '4.5 7 -5',
                    rotation: '0 -45 0',
                    scale: '1 1 1',
                    animating: false,
                    classes: ['cantap', 'display-img'],
                    material: {
                        transparent: true,
                        opacity: 0.4,
                        src: '#img-2',
                    },
                    shadow: {
                        receive: false
                    },
                    texture: carouselRight,
                    url: "https://darabase.com/",
                },
                {
                    id: "i3",
                    primitive: 'plane',
                    width: 4,
                    height: 2.25,
                    position: '-4.5 7 -5',
                    rotation: '0 45 0',
                    scale: '1 1 1',
                    animating: false,
                    classes: ['cantap', 'display-img'],
                    material: {
                        transparent: true,
                        opacity: 0.4,
                        src: '#img-3',
                    },
                    shadow: {
                        receive: false
                    },
                    texture: carouselLeft,
                    url: "https://darabase.com/",
                },
                {
                    id: "i4",
                    primitive: 'plane',
                    width: 4,
                    height: 2.25,
                    position: '6 7 0',
                    rotation: '0 -90 0',
                    scale: '1 1 1',
                    animating: false,
                    classes: ['cantap', 'display-img'],
                    material: {
                        transparent: true,
                        opacity: 0.4,
                        src: '#img-4',
                    },
                    shadow: {
                        receive: false
                    },
                    texture: carouselRight2,
                    url: "https://darabase.com/",
                },
                {
                    id: "i5",
                    primitive: 'plane',
                    width: 4,
                    height: 2.25,
                    position: '-6 7 0',
                    rotation: '0 90 0',
                    scale: '1 1 1',
                    animating: false,
                    classes: ['cantap', 'display-img'],
                    material: {
                        transparent: true,
                        opacity: 0.4,
                        src: '#img-5',
                    },
                    shadow: {
                        receive: false
                    },
                    texture: carouselLeft2,
                    url: "https://darabase.com/",
                }
            ]
        };

        if (product === 'video') {
            window.schema = videoSchema
        } else if (product === 'tower') {
            window.schema = towerSchema
        } else if (product === 'carousel') {
            window.schema = carouselSchema
        } else {
            window.schema = flatImageSchema
        }

        const setupScene = () => {
            console.log(window.schema);
            
            // if(isAdCreated) return;
            // isAdCreated = true;

            if (!!window.schema.groundPlane) {
                setupGroundPlane();
            }

            if (product === 'video') {
                createVideoSLAM();
                createVideoInstruction();
            } else if (product === 'tower') {
                // window.schema = towerSchema
                createTestEntities(window.schema.elements);
                createInstruction();
            } else if (product === 'carousel') {
                // window.schema = towerSchema
                createCarousel();
            } else if (product === 'flat-image') {
                // window.schema = towerSchema
                createFlatImage();
            }

            if (!!window.schema.sceneComponents) {
                for (let i = 0; i < window.schema.sceneComponents.length; i++) {
                    document.getElementById('scene').setAttribute(window.schema.sceneComponents[i], '');
                } 
            }
        };

        const getCubeFacePositionValue = (prop, value) => {
            switch (prop) {
                case 'left':
                case 'back':
                    return value.replace('val', -(window.schema.size / 2));
                    break;
                case 'right':
                case 'front':
                    return value.replace('val', window.schema.size / 2);
                    break;
                case 'top':
                    if (!!window.schema.height) {
                        return value.replace('val', window.schema.height / 2);
                    } else {
                        return value.replace('val', window.schema.size / 2);
                    }
                    break;
                case 'bottom':
                    if (!!window.schema.height) {
                        return value.replace('val', -(window.schema.height / 2));
                    } else {
                        return value.replace('val', -(window.schema.size / 2));
                    }
                    break;
            }
        }

        const createTestEntities = (elements) => {
            for (let i = 0; i < elements.length; i++) {
                const entity = document.createElement(elements[i].primitive);
                entity.id = elements[i].id;

                // console.log(elements[i].components.length);

                for (let x = 0; x < elements[i].components.length; x++) {
                    let component = elements[i].components[x];
                    // console.log(component)
                    if (component.indexOf('=') !== -1) {

                        component = elements[i].components[x].split('=');

                        if (component[0] === 'material') {

                            if (!!elements[i].texture) {
                                const newImg = document.createElement('img');
                                newImg.crossOrigin = 'anonymous';
                                newImg.id = `image-${i}`;
                                newImg.src = elements[i].texture;
                                document.querySelector('a-assets').appendChild(newImg)
                                entity.setAttribute(component[0], component[1] + 'src:#' + newImg.id);
                            } else {
                                entity.setAttribute(component[0], component[1]);
                            }

                            if (!!elements[i].color) {
                                entity.setAttribute(component[0], component[1] + 'color:' + elements[i].texture);
                            } else {
                                entity.setAttribute(component[0], component[1]);
                            }

                        } else {
                            if (component[1].indexOf('val') !== -1) {
                                entity.setAttribute(component[0], getCubeFacePositionValue(elements[i].id, component[1]));
                                console.log(getCubeFacePositionValue(elements[i].id, component[1]));
                            } else {
                                entity.setAttribute(component[0], component[1]);
                            }
                        }

                    } else {
                        if (component === 'width' || component === 'height' || component === 'data-url' || component === 'gltf-model') {
                            if (component === 'data-url' || component === 'gltf-model') {
                                if (component === 'gltf-model') {
                                    entity.setAttribute(component, 'url(' + elements[i].modelURL + ')');
                                } else {
                                    entity.setAttribute(component, elements[i].url);
                                }

                            } else {
                                if (!!window.schema.height && component === 'height') {
                                    if (elements[i].id === 'top' || elements[i].id === 'bottom') {
                                        entity.setAttribute(component, window.schema.size);
                                    } else {
                                        entity.setAttribute(component, window.schema.height);
                                    }
                                } else {
                                    entity.setAttribute(component, window.schema.size);
                                }
                            }
                        } else {
                            entity.setAttribute(component, '');
                        }
                    }
                }

                document.getElementById('scene').appendChild(entity);
            }
        }

        const createVideoSLAM = () => {

            const videoAsset = document.createElement('video');
            videoAsset.id = 'video';
            videoAsset.crossOrigin = 'anonymous';
            videoAsset.src = window.schema.elements.videoURL;
            videoAsset.setAttribute('loop', 'true');
            document.querySelector('a-assets').appendChild(videoAsset);

            const ring = document.createElement('a-entity');
            ring.setAttribute('geometry', 'primitive: ring;radiusInner:' + window.schema.elements.ringRadiusInner + ';radiusOuter: ' + window.schema.elements.ringRadiusOuter);
            ring.id = 'ring';
            ring.setAttribute('rotation', '-90 0 0');
            ring.setAttribute('material', 'side:double;shader:flat;color:' + window.schema.elements.ringColor);
            ring.classList.add('cantap');
            ring.setAttribute('tap-place-video', '');

            const video = document.createElement('a-video');
            video.setAttribute('src', window.schema.elements.thumbnail);
            video.setAttribute('width', window.schema.elements.videoWidth);
            video.setAttribute('height', window.schema.elements.videoHeight)
            video.setAttribute('position', '0 ' + window.schema.elements.videoOffsetTop + ' 0');

            video.setAttribute('material', 'opacity:' + window.schema.elements.startOpacity)
            video.id = 'video-3d';

            const cta = document.createElement('a-entity');
            cta.setAttribute('geometry', {
                primitive: 'plane',
                width: window.schema.elements.videoWidth / 2,
                height: 1.1
            });
            cta.setAttribute('material', {
                transparent: true,
                src: window.schema.elements.ctaTexture,
                opacity: window.schema.elements.startOpacity
            });
            cta.setAttribute('position', {
                x: 0,
                y: window.schema.elements.videoOffsetTop * 0.3,
                z: 0
            })
            cta.classList.add('cantap');
            cta.id = 'cta';
            cta.addEventListener('click', () => {
                window.open(window.schema.elements.ctaURL, '_blank');
            });

            if (!!window.schema.elements.lookAtUser) {
                video.setAttribute('look-at', '#camera');
                cta.setAttribute('look-at', '#camera');
            }

            document.getElementById('scene').appendChild(video);
            document.getElementById('scene').appendChild(cta);
            document.getElementById('scene').appendChild(ring);
        };

        const createCarousel = () => {

            const assetDepot = document.querySelector('a-assets');
            const sceneEntity = document.getElementById('scene');

            const ctaAsset = document.createElement('img');
            ctaAsset.id = 'cta';
            ctaAsset.src = '/carousel-cta.png';
            assetDepot.appendChild(ctaAsset);

            window.schema.elements.forEach((img, idx) => {
                const asset = document.createElement('img')
                asset.id = `img-${idx + 1}`;
                asset.crossOrigin = 'anonymous';
                asset.src = 'https://' + img;
                assetDepot.appendChild(asset);
            });

            window.schema.elements.forEach((imgEl, idx) => {
                // if (idx > manifest.contents.length - 1) return;
                // CTA
                const cta = document.createElement('a-entity');
                cta.setAttribute('position', '0 -1.65 0.01');
                cta.setAttribute('scale', idx !== 0 ? '0.001 0.001 0.001' : '1 1 1');
                cta.setAttribute('geometry', {
                    primitive: 'plane',
                    width: 3,
                    height: 0.67,
                });
                cta.setAttribute('material', {
                    transparent: true,
                    src: `#${ctaAsset.id}`,
                    opacity: idx !== 0 ? 0.4 : 1
                });
                cta.classList.add('cantap');
                cta.classList.add('cta');

                // IMG ENTITY
                const entity = document.createElement('a-entity');
                entity.id = imgEl.id;

                entity.setAttribute('position', imgEl.position);
                entity.setAttribute('scale', imgEl.scale);
                entity.setAttribute('rotation', imgEl.rotation);

                entity.setAttribute('geometry', {
                    primitive: imgEl.primitive,
                    width: imgEl.width,
                    height: imgEl.height
                });

                entity.setAttribute('material', {
                    transparent: imgEl.material.transparent,
                    opacity: imgEl.material.opacity,
                    src: imgEl.material.src
                });

                // entity.setAttribute('shadow', {
                //   receive: imgEl.shadow.receive
                // });

                entity.setAttribute('data-url', imgEl.url);

                if (imgEl.animating === false) {
                    entity.setAttribute('data-animating', imgEl.animating);
                }

                imgEl.classes.forEach(nameOfClass => {
                    entity.classList.add(nameOfClass);
                });

                entity.appendChild(cta);
                sceneEntity.appendChild(entity);
            })

            setTimeout(() => {
                aScene.setAttribute('focus-highlight', '');
            }, 1000);
        }

        const createFlatImage = () => {
            const flatImgAsset = document.createElement('img');
            flatImgAsset.src = window.schema.image;
            flatImgAsset.id = 'flat-image';

            document.querySelector('a-assets').appendChild(flatImgAsset);

            const flatImgEntity = document.createElement('a-entity');
            
            flatImgEntity.setAttribute('geometry', {
                primitive: 'plane',
                width: window.schema.width,
                height: window.schema.height
            });

            flatImgEntity.setAttribute('material', {src: '#flat-image'});

            flatImgEntity.setAttribute('position', {
                x: 0,
                y: (window.schema.height / 2) + window.schema.yOffset,
                z: 0
            });

            // flatImgEntity.classList.add('cantap');

            // flatImgEntity.addEventListener('click', () => {
            //     window.open(window.schema.url, '_blank');
            // })

            document.getElementById('scene').appendChild(flatImgEntity);

        }

        const setupGroundPlane = () => {
            let ground = document.createElement('a-plane');
            ground.id = 'ground';
            ground.setAttribute('rotation', '-90 0 0');
            ground.setAttribute('width', '1000');
            ground.setAttribute('height', '1000');
            ground.setAttribute('material', 'shader: shadow');
            ground.setAttribute('shadow', '');

            document.querySelector('a-scene').appendChild(ground);
        }

        const aScene = document.querySelector('a-scene');
        const launchButton = document.querySelector('.launch-btn')
        const splashScreen = document.getElementById('splash-screen')

        aScene.addEventListener('loaded', () => {
            document.getElementById('loading-block').classList.add('hidden');
        })

        launchButton.addEventListener('click', () => {
            splashScreen.classList.add('faded')
            aScene.setAttribute('xrweb', {alllowedDevices: 'any'})
            setupScene();
        })

        const createInstruction = () => {

            const imageTexture = document.createElement('img');
            imageTexture.id = 'img-inst';
            imageTexture.src = instTower;
            document.querySelector('a-assets').appendChild(imageTexture);

            const instructionEntity = document.createElement('a-entity');

            instructionEntity.setAttribute('geometry', {
                primitive: 'plane',
                width: window.schema.size,
                height: window.schema.size / 3
            });

            instructionEntity.setAttribute('material', {
                src: `#${imageTexture.id}`,
                transparent: true
            });

            instructionEntity.setAttribute('rotation', '-45 0 0');

            instructionEntity.setAttribute('position', {
                x: 0,
                y: 0.6,
                z: window.schema.size + 0.3
            });

            document.querySelector('a-scene').appendChild(instructionEntity);

        }

        const createVideoInstruction = () => {
            const instBlock = document.createElement('div');
            instBlock.classList.add('video-instruction');
            instBlock.innerHTML = 'Tap to place the video';
            document.getElementById('stage').appendChild(instBlock);
        }
        
    }

    render() {
        return(
            <>
                <div id='stage'>
                    <div id='splash-screen'>
                        <Logo />
                        {/* <Message text="Darabase Bonfire AR" /> */}
                        {/* <Message text="Tower Example" /> */}
                        <Message text="You will be prompted for camera/sensor permissions" />
                        <div className='launch-btn'></div>
                        <div className='bottom-bar'>
                            <Links/>
                            <DarabaseLogo />
                        </div>
                    </div>
                    <div id='loading-block'>
                        <h3>Loading...</h3>
                        <lottie-player
                            autoplay
                            loop
                            mode="normal"
                            src="https://assets2.lottiefiles.com/packages/lf20_ObshHL.json">
                        </lottie-player>
                    </div>
                </div>
            </>
        )
    }
}